import React from 'react'
import {
  imgFrame427322918,
  imgCompany1,
  imgLinkedInPng0,
  imgSwiggyPng0,
  imgGooglePng0,
  imgFlipkartPng0,
  imgImage801
} from './assets'

const CertificateSection = ({ skillName }) => {
  const companyLogos = [
    { src: "https://assets.learntube.ai/files/personalise/Pricing/LinkedIn%20%20png%200.webp", size: "h-[23.086px] w-[54.709px]" },
    { src: "https://assets.learntube.ai/files/personalise/Pricing/Swiggy%20%20png%200.webp", size: "h-[23.086px] w-[55.193px]" },
    { src: "https://assets.learntube.ai/files/personalise/Pricing/Google%20%20png%200.webp", size: "h-[23.086px] w-[55.193px]" },
    { src: "https://assets.learntube.ai/files/personalise/Pricing/Flipkart%20%20png%200.webp", size: "h-[23.086px] w-[55.193px]" },
    { src: "https://assets.learntube.ai/files/personalise/Pricing/image%20801.webp", size: "h-[17.167px] w-[51.285px]" }
  ]

  return (
    <div className="w-full border border-[#406aff] border-solid content-stretch flex items-center justify-between overflow-clip p-[24px] relative rounded-[24px] shadow-[0px_-8px_16px_0px_rgba(0,0,0,0.3)] shrink-0">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none rounded-[24px]">
        <div className="absolute inset-0 rounded-[24px]" style={{ backgroundImage: "url('data:image/svg+xml;utf8,<svg viewBox=\\'0 0 358 366.73\\' xmlns=\\'http://www.w3.org/2000/svg\\' preserveAspectRatio=\\'none\\'><rect x=\\'0\\' y=\\'0\\' height=\\'100%\\' width=\\'100%\\' fill=\\'url(%23grad)\\' opacity=\\'0.4000000059604645\\'/><defs><radialGradient id=\\'grad\\' gradientUnits=\\'userSpaceOnUse\\' cx=\\'0\\' cy=\\'0\\' r=\\'10\\' gradientTransform=\\'matrix(2.1447e-13 25.526 -38.365 -5.3167e-14 179 136.16)\\'><stop stop-color=\\'rgba(0,0,0,0)\\' offset=\\'0.10599\\'/><stop stop-color=\\'rgba(0,0,0,0.39437)\\' offset=\\'0.54788\\'/><stop stop-color=\\'rgba(0,0,0,1)\\' offset=\\'1\\'/></radialGradient></defs></svg>'), linear-gradient(90deg, rgba(64, 106, 255, 0.4) 0%, rgba(64, 106, 255, 0.4) 100%)" }} />
        <img alt="" className="absolute max-w-none object-cover opacity-30 rounded-[24px] size-full" src={'https://assets.learntube.ai/files/personalise/rays.webp'} />
      </div>
      
      <div className="w-full flex flex-[1_0_0] flex-col gap-[24px] items-center justify-center relative z-10">
        <p className="flex-[1_0_0] font-['Inter:Bold_Italic',sans-serif] font-bold italic leading-[0] min-h-px min-w-px relative text-[14px] text-center text-white w-[310px]">
          <span className="leading-[1.4]">Earn an Industry-Recognised Certificate</span>
          <span className="leading-[1.4]"> in </span>
          <span className="leading-[1.4] text-[#70aeff]">{skillName}</span>
        </p>
        
        <div className="grid-cols-[max-content] grid-rows-[max-content] inline-grid leading-[0] place-items-start relative shrink-0">
          <div className="col-1 h-[183.3px] ml-0 mt-0 relative row-1 w-[260.567px]">
            <div className="absolute content-stretch flex flex-col gap-[2.338px] items-start left-0 top-0">
              <div className="h-[185.006px] relative shrink-0 w-[262.087px]">
                <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={"https://assets.learntube.ai/files/personalise/Pricing/Group%2023417.webp"} />
              </div>
            </div>
          </div>
        </div>
        
        <div className="content-stretch flex flex-col gap-[12px] items-center relative shrink-0 w-full">
          <p className=" font-normal leading-none not-italic relative shrink-0 text-[12px] text-[rgba(255,255,255,0.7)] text-center">
            Recognised by 1100+ Hiring Companies Like
          </p>
          <div className="aspect-[199.55908203125/15.086247444152832] content-stretch flex items-center justify-between relative shrink-0 w-full">
            {companyLogos.map((logo, index) => (
              <div key={index} className={`relative shrink-0 ${logo.size}`}>
                <img alt="" className="absolute inset-0 max-w-none object-contain pointer-events-none size-full" src={logo.src} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CertificateSection